/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

export const dataQty = {
    al: 'Shipments must go to an ABC store.   ABC form is required.  Customers pays tax upon pick up at ABC store',
    ak: 'permitted only to certain wet areas',
    az: '12 cases/year',
    ar: '',
    ca: '',
    co: '',
    ct: '25 bottles/62 days - some exclusions may apply',
    dc: '1 case/month',
    de: '',
    fl: 'permitted only to certain wet areas',
    ga: '12 cases/year',
    hi: '6 cases/year - Maui County currently unavailable',
    id: '24 cases/year',
    il: '12 cases/year',
    in: '',
    ia: '',
    ks: '12 cases/year',
    ky: '10 cases/month',
    la: '',
    me: '12 cases/year - no products under 750mL',
    md: '18 cases/household/year',
    ma: '12 cases/year',
    mi: '',
    mn: '2 cases/year',
    ms: '',
    mo: '2 cases/month',
    mt: '18 cases/year',
    ne: '12 cases/year - some exclusions may apply',
    nv: '12 cases/year',
    nh: '12 cases/year - permitted only to certain wet areas',
    nj: '',
    nm: '2 cases/month',
    ny: '36 cases/year - permitted only to certain wet areas',
    nc: '2 cases/month',
    nd: '3 cases/month',
    oh: '',
    ok: '',
    or: '5 cases/month',
    pa: '36 cases/year',
    ri: '',
    sc: '2 cases/month',
    sd: '12 cases/year - limited products available',
    tn: '1 case/month - up to 3 cases/year',
    tx: '45 bottles/month - up to 181 bottles/year',
    ut: '',
    vt: '12 cases/year',
    va: '2 cases/month',
    wa: '',
    wv: '2 cases/month',
    wi: '12 cases/year',
    wy: '2 cases/year',
};
